module.exports = __webpack_public_path__ + "static/media/grid.a24e7e21.svg";